import { render, staticRenderFns } from "./cadastroItems.vue?vue&type=template&id=4615bb38&scoped=true&"
import script from "./cadastroItems.vue?vue&type=script&lang=js&"
export * from "./cadastroItems.vue?vue&type=script&lang=js&"
import style0 from "./cadastroItems.vue?vue&type=style&index=0&id=4615bb38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4615bb38",
  null
  
)

export default component.exports